import styled, { css } from 'styled-components';

export const EducationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #010606;
`;

export const EducationWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 72px 50px;

  @media screen and (max-width: 786px) {
    padding: 48px 20px;
  }
`;

export const Educations = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: auto;
  padding: 80px 0;
`;

export const DocumentBtn = styled.button`
  border-radius: 50px;
  white-space: nowrap;
  padding: 4px 16px;
  font-size: 12px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-top: 12px;
  margin-left: auto;

  ${({ isFirst }) =>
    isFirst
      ? css`
          background-color: #fff;
          border: 1px solid #010606;
          color: #010606;
        `
      : css`
          background-color: #010606;
          border: 1px solid #fff;
          color: #fff;
        `}
`;

export const EducationCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ isFirst }) => (isFirst ? 'transparent' : '#fff')};
  border-radius: 10px;
  padding: 24px;
  min-width: 460px;
  max-width: 460px;
  width: 100%;
  height: 100%;
  transition: all 0.2s ease-in-out;
  position: relative;
  color: ${({ isFirst }) => (isFirst ? '#fff' : '#010606')};
  border: 1px solid ${({ isFirst }) => (isFirst ? '#fff' : 'transparent')};

  & + & {
    margin-left: 48px;
  }

  &:hover {
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    ${DocumentBtn} {
      transition: all 0.2s ease-in-out;
      background: #fff;
      color: #010606;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 8px;
    border-radius: 4px;
    min-width: 250px;
    max-width: 250px;

    & + & {
      margin-left: 12px;
    }
  }
`;

export const EducationH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 32px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const EducationH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 0px;
`;

export const EducationH3 = styled.h3`
  font-size: 0.8rem;
  font-weight: 400;
  margin-bottom: 0px;
`;

export const EducationH4 = styled.h4`
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 0px;
`;

export const EducationP = styled.p`
  font-size: 0.9rem;
  margin-top: 10px;
`;

export const Bar = styled.div`
  height: 2px;
  width: calc(100% + 2px + 48px);
  position: absolute;
  top: -48px;
  left: 0;
  background-color: #fff;

  ${({ isLast, isFirst }) =>
    isLast
      ? css`
          width: calc(50% + 1px);
        `
      : isFirst
      ? css`
          width: calc(50% + 1px + 48px);
          left: calc(50% + 1px);

          @media screen and (max-width: 768px) {
            width: calc(50% + 1px + 24px);
          }
        `
      : null}

  @media screen and (max-width: 768px) {
    width: calc(100% + 2px + 24px);
  }
`;

export const CircleDot = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  top: calc(-48px - 16px);
  left: calc(50% - 16px);

  ${({ isFirst }) =>
    isFirst
      ? css`
          background-color: #010606;
          border: 3px solid #fff;
        `
      : css`
          background-color: #fff;
          border: 3px solid #010606;
        `}

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    top: calc(-48px - 10px);
    left: calc(50% - 10px);
  }
`;
